<template>
  <!-- 多页签组件 -->
  <div class="tab-wrap">
    <div
      class="tab-item"
      :class="{
        active: !!tab.active,
        fixed: tab.type === 'fixed',
        'is-last': index === tabs.length - 1
      }"
      v-for="(tab, index) in tabs"
      :key="tab.id"
      @click="onSelectTab(tab)"
      @contextmenu.prevent="onContextMenu($event, tab, index)"
      @mouseleave.stop="onTabMouseLeave"
    >
      <div class="item-content">
        <span class="tab-text ellipsis" :title="tab.title">{{
          tab.title
        }} </span>
        <i
          class="icon el-icon-close"
          @click.stop="onRemoveTab(tab, index)"
          v-if="tab.type !== 'fixed' && tabs.length > 1"
        ></i>
      </div>
    </div>
    <div
      v-show="showMenu"
      class="context-menu-wrap"
      :style="{ left: x, right: y }"
      @mouseenter.stop="onMemuMouseEnter"
      @mouseleave.stop="onMemuMouseLeave"
    >
      <ul>
        <li class="menu-item" @click="onMenuRefresh">刷新当前</li>
        <!-- <li class="menu-item" @click="onMenuClose" v-show="tabs.length > 1">
          关闭
        </li> -->
        <li
          class="menu-item"
          @click="onMenuCloseOther"
          v-show="tabs.length > 1"
        >
          关闭其他
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapMutations, mapState } from 'vuex';
export default {
  data() {
    return {
      x: 0, // 右键菜单位置
      y: 0, // 右键菜单位置
      showMenu: false, // 显示右键菜单
      inMenu: false, // 鼠标进入工具栏区域
      tabTimer: null, // 隐藏菜单计时器
      tabIndex: -1, // 指定操作Tab索引
      menuOperateTabIndex: -1 // 右键菜单操作tab索引
    };
  },
  computed: {
    ...mapState({
      tabs: state => state.tabs.tabs, // 缓存tab页
      excludeTabs: state => state.tabs.excludeTabs // 非缓存Tab
    }),
    ...mapGetters({
      platMainMenus: 'platMainMenus' // 主菜单列表扁平化为数组
    })
  },
  methods: {
    ...mapMutations({
      removeTab: 'tabs/removeTab', // 关闭/移除页签
      setTabs: 'tabs/setTabs', // 更新页签组
      setExcludeTabs: 'tabs/setExcludeTabs' // 更新非缓存页签
    }),
    // 选择页签
    onSelectTab(tab) {
      if (tab.path === this.$route.path) {
        // 选择当前页面页签不处理
        return;
      }
      this.$router.push(tab.url);
    },
    // 关闭/移除页签
    onRemoveTab(tab, index) {
      if (tab.active) {
        // 关闭活动页签
        this.removeTab(index);
        const nextTab = this.tabs[index] || this.tabs[index - 1] || null;
        nextTab && this.onSelectTab(nextTab);
      } else {
        // 关闭非活动页签
        this.removeTab(index);
      }
    },
    // tab项鼠标离开
    onTabMouseLeave() {
      this.tabTimer = setTimeout(() => {
        if (!this.inMenu) {
          this.showMenu = false;
        }
      }, 500);
    },
    // 右键事件
    onContextMenu(event, tab, index) {
      if (!tab.active) {
        return;
      }
      this.showMenu = false;
      const target = {
        x: event.pageX,
        y: event.pageY
      };
      this.x = target.x + 'px';
      this.y = target.y + 'px';
      this.menuOperateTabIndex = index;
      this.showMenu = true;
    },
    // 菜单鼠标划入
    onMemuMouseEnter() {
      this.inMenu = true;
      clearTimeout(this.tabTimer);
    },
    // 菜单鼠标离开
    onMemuMouseLeave() {
      setTimeout(() => {
        this.inMenu = false;
        this.showMenu = false;
      }, 100);
    },
    // 刷新
    onMenuRefresh() {
      const tab = this.tabs[this.menuOperateTabIndex];
      this.setExcludeTabs([tab.name]);
      this.$router.push({
        name: 'CommonRefresh'
      });
      this.showMenu = false;
    },
    // 关闭
    onMenuClose() {
      this.onRemoveTab(
        this.tabs[this.menuOperateTabIndex],
        this.menuOperateTabIndex
      );
      this.showMenu = false;
    },
    // 关闭其他
    onMenuCloseOther() {
      const tab = _.cloneDeep(this.tabs[this.menuOperateTabIndex]);
      this.setTabs([tab]);
      // this.$router.push(tab.url);
      this.showMenu = false;
    }
  }
};
</script>
<style lang="stylus" scoped>
.tab-wrap {
  box-sizing border-box;
  width 100%;
  height 40px;
  overflow-x auto
  overflow-y hidden
  white-space nowrap
  .tab-item {
    box-sizing border-box;
    display:inline-block;
    width 150px;
    padding 10px 0;
    cursor: pointer;
    background #F6F7FB
    font-size 14px
    user-select none
    font-family: PingFangSC, PingFangSC-Regular;
    .item-content {
      display flex;
      align-items center;
      justify-content space-between;
      padding 0 20px;
      border-left 1px solid rgba(204,204,204,0.6);

      .tab-text {
        // width 150px;
        color: #606677;
      }
    }
    &:first-child{
      .item-content {
        border-left-color transparent
      }
    }
    &.is-last {
      margin-right 20px
    }
    &.active {
      background #fff
      border-radius: 4px 4px 0 0;
      .item-content {
        border-left-color transparent

        .tab-text {
          color: #0553A5;
        }
      }
      & + .tab-item {
        .item-content {
          border-left-color transparent
        }
      }
      .icon {
        color #09152D
      }
    }
    .icon {
      display inline-block
      vertical-align middle
      margin-left 4px
      opacity: 0.8;
      color #8186A5
      &:hover {
        opacity: 1;
        font-weight bold
      }
    }
  }
}
.context-menu-wrap {
  position fixed
  z-index 99
  left: 0;
  right:0;
  width 120px
  border-radius 2px
  font-size 14px
  border 1px solid #f1f1f1
  border-bottom none
  .menu-item {
    cursor: pointer;
    padding 8px 16px
    background #ffffff
    border-bottom 1px solid #f1f1f1
    text-align: center;
    &:hover {
      color #0B51C1
      // color: $themeFontColor;
      // background red
    }
  }
}
</style>
